import { Div } from "@tblabs/truffle";
import { NumberInputWithIcon } from "../../../Components/General/NumberInputWithIcon";
import { SelectInputWithIcon } from "../../../Components/General/SelectInputWithIcon";
import { Translations } from "../../../Translations/Translations";
import { CameraPictureControl } from "./CameraPictureControl";


export class CameraPictureSettingsBox extends Div
{
    constructor(private _lang: Translations, _control: CameraPictureControl)
    {
        super("CustomConfigurator");

        this.Visible(_control.ShowCustomConfigurator, "flex");

        this.Append(
            new NumberInputWithIcon("↔", _control.PictureWidth, 100, _control.PictureMaxWidth, 100, this._lang.Width),
            new NumberInputWithIcon("↕", _control.PictureHeight, 100, _control.PictureMaxHeight, 100, this._lang.Height),
            new NumberInputWithIcon("⨂", _control.PictureBrightness, 0, 100, 1, this._lang.Brightness),
            new NumberInputWithIcon("◩", _control.PictureContrast, -100, 100, 1, this._lang.Contrast),
            new SelectInputWithIcon("↺", _control.PictureRotation, { "0°": 0, "90°": 90, "180°": 180, "270°": 270 }, this._lang.Rotation)
        );
    }
}
